/**
 * Automotive Brand Logos System (184 Official Worldwide Brands)
 * Powered by https://github.com/vehiclespecs/brand-logos
 */

export const CDN_BASE_URL = 'https://cdn.jsdelivr.net/gh/vehiclespecs/brand-logos@main';
export const FALLBACK_CDN_URL = 'https://raw.githubusercontent.com/vehiclespecs/brand-logos/main';

export const CAR_BRAND_LOGOS: Record<string, string> = {
  "Abarth": "abarth-logo.svg",
  "Acura": "acura-logo.svg",
  "Aion": "aion-logo.svg",
  "AITO": "aito-logo.svg",
  "Aiways": "aiways-logo.svg",
  "Aixam": "aixam-logo.svg",
  "Alfa Romeo": "alfa-romeo-logo.svg",
  "Alpina": "alpina-logo.svg",
  "Alpine": "alpine-logo.svg",
  "Ariel": "ariel-logo.svg",
  "ARO": "aro-logo.svg",
  "Aston Martin": "aston-martin-logo.svg",
  "Audi": "audi-logo.svg",
  "Austin": "austin-logo.svg",
  "Autobianchi": "autobianchi-logo.svg",
  "Avatr": "avatr-logo.svg",
  "BAC": "bac-logo.svg",
  "BAIC": "baic-logo.svg",
  "BAW": "baw-logo.svg",
  "Bentley": "bentley-logo.svg",
  "Bertone": "bertone-logo.svg",
  "BMW": "bmw-logo.svg",
  "Bollinger": "bollinger-logo.svg",
  "Brabham": "brabham-logo.svg",
  "Brilliance": "brilliance-logo.png",
  "Bugatti": "bugatti-logo.svg",
  "Buick": "buick-logo.png",
  "BYD": "byd-logo.svg",
  "Cadillac": "cadillac-logo.png",
  "Callaway": "callaway-logo.svg",
  "Caterham": "caterham-logo.svg",
  "Changan": "changan-logo.png",
  "Chery": "chery-logo.png",
  "Chevrolet": "chevrolet-logo.png",
  "Chrysler": "chrysler-logo.svg",
  "Citro\u00ebn": "citroen-logo.svg",
  "Cupra": "cupra-logo.svg",
  "Dacia": "dacia-logo.svg",
  "Dadi": "dadi-logo.svg",
  "Daewoo": "daewoo-logo.png",
  "Daihatsu": "daihatsu-logo.svg",
  "Daimler": "daimler-logo.svg",
  "Datsun": "datsun-logo.png",
  "DeLorean": "de-lorean-logo.svg",
  "De Tomaso": "de-tomaso-logo.png",
  "Deepal": "deepal-logo.svg",
  "Denza": "denza-logo.svg",
  "DeSoto": "desoto-logo.png",
  "DFSK": "dfsk-logo.svg",
  "Dodge": "dodge-logo.png",
  "Dongfeng": "dongfeng-logo.png",
  "DS Automobiles": "ds-logo.svg",
  "e.GO": "ego-logo.svg",
  "EMC": "emc-logo.svg",
  "EVO": "evo-logo.svg",
  "FAW": "faw-logo.svg",
  "Ferrari": "ferrari-logo.svg",
  "Fiat": "fiat-logo.svg",
  "Fisker": "fisker-logo.png",
  "Ford": "ford-logo.png",
  "GAZ": "gaz-logo.png",
  "Geely": "geely-logo.svg",
  "Genesis": "genesis-logo.svg",
  "Geo": "geo-logo.svg",
  "Geometry": "geometry-logo.svg",
  "Ginetta": "ginetta-logo.svg",
  "GMC": "gmc-logo.png",
  "Great Wall": "great-wall-logo.png",
  "Haval": "haval-logo.png",
  "Hennessey": "hennessey-logo.svg",
  "Hispano-Suiza": "hispano-suiza-logo.png",
  "Holden": "holden-logo.svg",
  "Honda": "honda-logo.png",
  "Hongqi": "hongqi-logo.png",
  "Hummer": "hummer-logo.svg",
  "Hyundai": "hyundai-logo.svg",
  "iCar": "icar-logo.svg",
  "ICH-X": "ich-x-logo.svg",
  "IMSA": "imsa-logo.svg",
  "INEOS": "ineos-logo.svg",
  "Infiniti": "infiniti-logo.svg",
  "Invicta": "invicta-logo.svg",
  "Isdera": "isdera-logo.svg",
  "Isuzu": "isuzu-logo.svg",
  "JAC": "jac-logo.png",
  "Jaecoo": "jaecoo-logo.svg",
  "Jaguar": "jaguar-logo.svg",
  "Jeep": "jeep-logo.svg",
  "Jetour": "jetour-logo.svg",
  "Karma": "karma-logo.png",
  "KGM": "kgm-logo.svg",
  "Kia": "kia-logo.svg",
  "Koenigsegg": "koenigsegg-logo.svg",
  "Lada": "lada-logo.svg",
  "Lamborghini": "lamborghini-logo.png",
  "Lancia": "lancia-logo.png",
  "Land Rover": "land-rover-logo.svg",
  "Leapmotor": "leapmotor-logo.png",
  "Lexus": "lexus-logo.png",
  "Ligier": "ligier-logo.png",
  "Lincoln": "lincoln-logo.svg",
  "Lister": "lister-logo.png",
  "Lotus": "lotus-logo.svg",
  "Lucid": "lucid-logo.png",
  "Mahindra": "mahindra-logo.png",
  "Maruti Suzuki": "maruti-logo.svg",
  "Maserati": "maserati-logo.png",
  "Maxus": "maxus-logo.png",
  "Maybach": "maybach-logo.png",
  "Mazda": "mazda-logo.svg",
  "McLaren": "mclaren-logo.svg",
  "Mercedes-Benz": "mercedes-benz-logo.svg",
  "Mercury": "mercury-logo.png",
  "MG": "mg-logo.png",
  "Mini": "mini-logo.svg",
  "Mitsubishi": "mitsubishi-logo.svg",
  "Mitsuoka": "mitsuoka-logo.png",
  "Morgan": "morgan-logo.png",
  "Morris": "morris-logo.png",
  "NIO": "nio-logo.png",
  "Nissan": "nissan-logo.svg",
  "Noble": "noble-logo.png",
  "Oldsmobile": "oldsmobile-logo.png",
  "Omoda": "omoda-logo.png",
  "Opel": "opel-logo.svg",
  "ORA": "ora-logo.png",
  "Pagani": "pagani-logo.png",
  "Perodua": "perodua-logo.png",
  "Peugeot": "peugeot-logo.svg",
  "Pininfarina": "pininfarina-logo.png",
  "Plymouth": "plymouth-logo.png",
  "Polaris": "polaris-logo.png",
  "Polestar": "polestar-logo.png",
  "Pontiac": "pontiac-logo.png",
  "Porsche": "porsche-logo.svg",
  "Praga": "praga-logo.png",
  "Proton": "proton-logo.png",
  "Puch": "puch-logo.svg",
  "Puma": "puma-logo.png",
  "RAM": "ram-logo.svg",
  "Reliant": "reliant-logo.png",
  "Renault": "renault-logo.svg",
  "Rimac": "rimac-logo.png",
  "Rivian": "rivian-logo.svg",
  "Rolls-Royce": "rolls-royce-logo.svg",
  "Rover": "rover-logo.png",
  "RUF": "ruf-logo.png",
  "Saab": "saab-logo.png",
  "Saleen": "saleen-logo.png",
  "Saturn": "saturn-logo.png",
  "SCG": "scg-logo.png",
  "Scion": "scion-logo.png",
  "SEAT": "seat-logo.svg",
  "Seres": "seres-logo.png",
  "\u0160koda": "skoda-logo.svg",
  "Smart": "smart-logo.png",
  "SsangYong": "ssangyong-logo.png",
  "Subaru": "subaru-logo.png",
  "Suzuki": "suzuki-logo.svg",
  "SWM": "swm-logo.png",
  "Talbot": "talbot-logo.png",
  "Tata": "tata-logo.png",
  "Tatra": "tatra-logo.png",
  "Tesla": "tesla-logo.svg",
  "TOGG": "togg-logo.svg",
  "Toyota": "toyota-logo.svg",
  "Trabant": "trabant-logo.svg",
  "TVR": "tvr-logo.png",
  "UAZ": "uaz-logo.png",
  "Vauxhall": "vauxhall-logo.png",
  "Venturi": "venturi-logo.png",
  "VinFast": "vinfast-logo.png",
  "Volkswagen": "volkswagen-logo.svg",
  "Volvo": "volvo-logo.svg",
  "W Motors": "w-motors-logo.png",
  "Wartburg": "wartburg-logo.png",
  "Westfield": "westfield-logo.png",
  "Xiaomi": "xiaomi-logo.svg",
  "XPeng": "xpeng-logo.png",
  "Yangwang": "yangwang-logo.svg",
  "ZAZ": "zaz-logo.png",
  "Zeekr": "zeekr-logo.png",
  "Zenvo": "zenvo-logo.png",
  "Zotye": "zotye-logo.png"
};

export const BRAND_ALIASES: Record<string, string> = {
  "mercedes": "Mercedes-Benz",
  "mercedesbenz": "Mercedes-Benz",
  "benz": "Mercedes-Benz",
  "chevy": "Chevrolet",
  "vw": "Volkswagen",
  "landrover": "Land Rover",
  "rollsroyce": "Rolls-Royce",
  "alfa": "Alfa Romeo",
  "aston": "Aston Martin",
  "haval / gwm": "Haval",
  "gwm": "Great Wall",
  "greatwall": "Great Wall",
  "maruti": "Maruti Suzuki",
  "delorean": "DeLorean",
  "detomaso": "De Tomaso",
  "ds": "DS Automobiles",
  "skoda": "\u0160koda",
  "citroen": "Citro\u00ebn",
  "wmotors": "W Motors",
  "ego": "e.GO",
  "ichx": "ICH-X"
};

export interface BrandLogoInfo {
  name: string;
  filename: string;
  url: string;
  fallbackUrl: string;
  isSvg: boolean;
}

/**
 * Normalizes input string for robust case-insensitive, punctuation-insensitive matching.
 */
function normalizeKey(str: string): string {
  return str.toLowerCase().replace(/[^a-z0-9]/g, '');
}

// Pre-compute normalized lookup map for O(1) matching
const NORMALIZED_LOOKUP: Record<string, { name: string; filename: string }> = {};

for (const [name, filename] of Object.entries(CAR_BRAND_LOGOS)) {
  NORMALIZED_LOOKUP[normalizeKey(name)] = { name, filename };
  const baseSlug = filename.replace('-logo.svg', '').replace('-logo.png', '');
  NORMALIZED_LOOKUP[normalizeKey(baseSlug)] = { name, filename };
}

for (const [alias, canonicalName] of Object.entries(BRAND_ALIASES)) {
  const target = CAR_BRAND_LOGOS[canonicalName];
  if (target) {
    NORMALIZED_LOOKUP[normalizeKey(alias)] = { name: canonicalName, filename: target };
  }
}

/**
 * Retrieve car brand logo info with high-res CDN url and fallback.
 */
export function getCarBrandLogo(brandOrMake?: string | null): BrandLogoInfo | null {
  if (!brandOrMake || typeof brandOrMake !== 'string') return null;

  const trimmed = brandOrMake.trim();
  if (!trimmed) return null;

  // Direct match
  if (CAR_BRAND_LOGOS[trimmed]) {
    const filename = CAR_BRAND_LOGOS[trimmed];
    return {
      name: trimmed,
      filename,
      url: `${CDN_BASE_URL}/${filename}`,
      fallbackUrl: `${FALLBACK_CDN_URL}/${filename}`,
      isSvg: filename.endsWith('.svg'),
    };
  }

  // Normalized match
  const norm = normalizeKey(trimmed);
  const found = NORMALIZED_LOOKUP[norm];
  if (found) {
    return {
      name: found.name,
      filename: found.filename,
      url: `${CDN_BASE_URL}/${found.filename}`,
      fallbackUrl: `${FALLBACK_CDN_URL}/${found.filename}`,
      isSvg: found.filename.endsWith('.svg'),
    };
  }

  // Partial match: checks if key starts with or contains
  for (const [key, val] of Object.entries(NORMALIZED_LOOKUP)) {
    if (norm.startsWith(key) || key.startsWith(norm)) {
      return {
        name: val.name,
        filename: val.filename,
        url: `${CDN_BASE_URL}/${val.filename}`,
        fallbackUrl: `${FALLBACK_CDN_URL}/${val.filename}`,
        isSvg: val.filename.endsWith('.svg'),
      };
    }
  }

  return null;
}

/**
 * Convenience helper to return just the CDN URL or an empty string.
 */
export function getCarBrandLogoUrl(brandOrMake?: string | null): string {
  const info = getCarBrandLogo(brandOrMake);
  return info ? info.url : '';
}
